import { withLazy } from 'app/hocs/withLazy'

export const AuthCompleted = withLazy(
  () => import('features/Auth/components/AuthCompleted/AuthCompleted'),
)
